module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"picked_up_by":"Picked up by","update_tracking_info":"Update tracking info","cod":"COD"},"id":{"picked_up_by":"Dipungut oleh","update_tracking_info":"Perbaru info pelacakan","cod":"COD"}}')
  delete Component.options._Ctor
}
